import * as constants from '../../constants';
import textButton from '../../shared-ui/text-button';

const width = 140;
const height = 40;

export default function( selectionMode, data, eventEmitter ) {
  const text = selectionMode ? 'SELECT ALL' : 'CLEAR';
  const bgColour = selectionMode ? constants.lightBlue : constants.red;

  const btn = textButton({ text, bgColour, width, height });

  update();

  function update() {
    const enabled = data.some(elm => elm.selected !== selectionMode);
    btn.interactive = enabled;
    btn.alpha = enabled ? 1 : 0.3;
  }

  btn.on('pointerdown', () => {
    data.forEach(elm => elm.selected = selectionMode);
    eventEmitter.emit('update-selection');
  });

  eventEmitter.on('update-selection', update);

  return btn;
};
